<template>
  <div>
    <apexchart type="bar" :options="chartOptions" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import RebanhoDeRecria from "../../class/RebanhoDeRecria";
import RebanhoDeReproducao from "../../class/RebanhoDeReproducao";
import DadosDespesasAnimais from "../../class/DadosDespesasAnimal.js";
import DadosDasDespesas from "../../class/DadosDasDespesas.js";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosDespesasServicos from "../../class/DadosDespesasServicos.js";
import DadosDasReceitas from "../../class/DadosDasReceitas.js";
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
import ReceitaAnual from "../../class/ReceitaAnual.js";
import ReceitaAnualAbate from "../../class/ReceitaAnualAbate.js";
import OutrasReceitas from "../../class/OutrasReceitas.js";

var dadosEstoqueInicial = [];
var dadosTotalComprasBovinos = [];
var dadosProduçãoKGVivo = [];
var dadosTotalVendaBovinos = [];
var dadosEstoqueFinal = [];

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => {
    return {
      simulation: "",
      chartOptions: {
        chart: {
          id: "vuechart-example"
        },
        colors: ["#F2811D"],
        xaxis: {
          categories: [
            "Estoque rebanho início do ano",
            "Compras de bovinos",
            "Produção kg de peso vivo",
            "Vendas de bovinos",
            "Estoque rebanho final do ano"
          ]
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return parseFloat(val.toFixed(2)).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL"
            });
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              var valor = val;
              if (typeof valor !== "undefined") {
                return parseFloat(valor.toFixed(2)).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                });
              } else return valor;
            }
          }
        }
      },

      series: [
        {
          name: "",
          data: dadosEstoqueInicial
        }
      ],
      largura: "100%"
    };
  },

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    preencherGrafico: function() {
      this.$db.simulation
        .get({ code: this.simulation.code }, dado => {
          var manutencao = new DadosDespesasManutencao(dado.dadosManutencao);
          var despesas = new DadosDasDespesas(dado.dadosDasDespesas);
          var servicos = new DadosDespesasServicos(dado.dadosDespesasServicos);
          var despesasAnimais = new DadosDespesasAnimais(
            dado.dadosDespesasAnimal
          );
          var receitas = new DadosDasReceitas(dado.proLabore);
          var pastagens = new DadosRecursosPastagensOutros(
            dado.dadosRecursosPastagensOutros
          );
          var instalacoes = new DadosRecursosInstalacoes(
            dado.dadosRecursosInstalacoes
          );
          var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
          var recursosAnimais = new DadosRecursosAnimais(
            dado.dadosRecursosAnimais
          );
          var rebanhoReproducao = new RebanhoDeReproducao(
            dado.rebanhoReproducao
          );
          var abate = new ReceitaAnualAbate(dado.bovinoAbate);
          var outro = new ReceitaAnual(dado.bovinoOutro);
          var recria = new RebanhoDeRecria(dado.rebanhoRecria);
          var outrasReceitas = new OutrasReceitas(dado.outrasReceitas);

          var biblioteca = [
            BibliotecaDeCalculos.RebanhoDeRecria(recria),
            BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
            BibliotecaDeCalculos.RebanhoTotal(
              BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
              BibliotecaDeCalculos.RebanhoDeRecria(recria)
            ),
            BibliotecaDeCalculos.RecursosPastagens(pastagens),
            BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
            BibliotecaDeCalculos.RecursosMaquinas(maquinas),
            BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
            BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
            BibliotecaDeCalculos.Despesas(despesas),
            BibliotecaDeCalculos.DadosDasReceitas(receitas),
            BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
            BibliotecaDeCalculos.DespesasServicos(servicos),
            BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
            BibliotecaDeCalculos.OutrasReceitas(outrasReceitas),
            BibliotecaDeCalculos.CalculosDosGraficos(
              BibliotecaDeCalculos.RecursosPastagens(pastagens),
              BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
              BibliotecaDeCalculos.RecursosMaquinas(maquinas),
              BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
              BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
              BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
              BibliotecaDeCalculos.Despesas(despesas),
              BibliotecaDeCalculos.DadosDasReceitas(receitas),
              BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
              BibliotecaDeCalculos.DespesasServicos(servicos),
              BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
              BibliotecaDeCalculos.RebanhoDeRecria(recria),
              BibliotecaDeCalculos.OutrasReceitas(outrasReceitas)
            )
          ];
          return biblioteca;
        })
        .then(
          g => (
            (dadosEstoqueInicial[0] = g[2].estoqueIncial()),
            (dadosEstoqueInicial[1] = g[14].totalCompraBovinos()),
            (dadosEstoqueInicial[2] = g[14].producaoKGVivo()),
            (dadosEstoqueInicial[3] = g[12].totalVendaBovinos()),
            (dadosEstoqueInicial[4] = g[2].estoqueFinal())
          )
        );
    }
  }
};
</script>
<style scoped>
</style>